import { render, staticRenderFns } from "./FishManage.vue?vue&type=template&id=47c38ea8&scoped=true&"
import script from "./FishManage.vue?vue&type=script&lang=js&"
export * from "./FishManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c38ea8",
  null
  
)

export default component.exports